// Generated by scripts/export_narration.py: narration of each lesson video.
export const VIDEO_NARRATION = [
 {
  "id": "intro-1",
  "title": "Lesson 1 (piano) intro video",
  "file": "lesson1-intro.mp4",
  "lines": [
   "Welcome to your very first lesson. Grab some manuscript paper — you can download it free on this page — and let's start reading music.",
   "This is the stave. It has five lines, and each line on its own is called a ledger line. We number the lines from the bottom to the top: one to five.",
   "Notes can sit on the lines, or in the spaces in between. The higher a note sits on the stave, the higher it sounds — just like climbing a ladder.",
   "Need to go higher or lower? Draw a short ledger line through the note — keeping exactly the same spacing as the stave.",
   "Then we give the notes letter names: A to G, and then they start again. On a keyboard, C is to the left of the two black keys, and F is to the left of the three.",
   "Finally, a clef tells us where those letters sit. You'll meet the G clef, Middle C, and every note from Middle C up to A. Let's begin!",
   "This lesson also has a piano game to test yourself: Find the note. Tap the key that matches the note, in a ten-note round, a black key round or the thirty-second speed challenge. You can also name the key that lights up, or find notes from the treble and bass clef. See if you can beat your best score!"
  ]
 },
 {
  "id": "intro-1g",
  "title": "Lesson 1 (guitar) intro video",
  "file": "lesson1g-intro.mp4",
  "lines": [
   "Welcome to your very first lesson. Grab some manuscript paper — you can download it free on this page — and let's start reading music.",
   "This is the stave. It has five lines, and each line on its own is called a ledger line. We number the lines from the bottom to the top: one to five.",
   "Guitarists, your music often has a second stave underneath, called TAB. It has six lines, one for each string. The top line is the thinnest string, high E, and the bottom line is the thickest string, low E.",
   "Notes can sit on the lines, or in the spaces in between. The higher a note sits on the stave, the higher it sounds — just like climbing a ladder.",
   "TAB only uses its lines, never the spaces. A number on a line tells you which fret to press on that string, and zero means play the string open.",
   "Need to go higher or lower? Draw a short ledger line through the note — keeping exactly the same spacing as the stave.",
   "Guitar music goes below the stave a lot. The open low E string is written just below the third ledger line under the stave. TAB never needs ledger lines: it just shows the string and fret.",
   "Then we give the notes letter names: A to G, and then they start again. On a keyboard, C is to the left of the two black keys, and F is to the left of the three.",
   "On the guitar, each open string has a letter name: from the thickest to the thinnest, E, A, D, G, B and E. As you go up the frets, each string climbs through the musical alphabet.",
   "Finally, a clef tells us where those letters sit. You'll meet the G clef, Middle C, and every note from Middle C up to A. Let's begin!",
   "Guitarists read the treble clef, and the guitar sounds an octave lower than written. In guitar music, Middle C is played on the third fret of the A string.",
   "Here's Middle C up to A on the stave, with the TAB underneath showing where to play each note. Middle C is the third fret on the A string. The stave tells you what note to play, and the TAB tells you where to play it.",
   "This lesson also has quick games to test yourself: name the note on the stave, find it on the fretboard, name notes on TAB, and write notes on the TAB. See if you can beat your best score!"
  ]
 },
 {
  "id": "intro-1s",
  "title": "Lesson 1 (voice) intro video",
  "file": "lesson1s-intro.mp4",
  "lines": [
   "Welcome to your very first lesson. Grab some manuscript paper — you can download it free on this page — and let's start reading music.",
   "Singers, in this course you'll see the stave side by side with the keyboard and the words you sing, so you learn how they work together.",
   "This is the stave. It has five lines, and each line on its own is called a ledger line. We number the lines from the bottom to the top: one to five.",
   "Notes can sit on the lines, or in the spaces in between. The higher a note sits on the stave, the higher it sounds — just like climbing a ladder.",
   "Need to go higher or lower? Draw a short ledger line through the note — keeping exactly the same spacing as the stave.",
   "Then we give the notes letter names: A to G, and then they start again. On a keyboard, C is to the left of the two black keys, and F is to the left of the three.",
   "Finally, a clef tells us where those letters sit. You'll meet the G clef, Middle C, and every note from Middle C up to A. Let's begin!",
   "Here's Middle C up to A on the stave, with the same notes on the keyboard underneath. Find the key, hear it, and sing it back.",
   "In songs, the words are written under the stave. Each syllable sits under the note you sing it on.",
   "Then find your range. Copy a scale, starting on the A below Middle C, going up, then down. Sing out, so the microphone can hear you clearly. Where your natural voice changes into your head voice shows your range, and your voice part: soprano, alto, tenor or bass.",
   "Then play the singing games: name the note, higher or lower, write it on the stave, and sing the note. See if you can beat your best score!"
  ]
 },
 {
  "id": "intro-1d",
  "title": "Lesson 1 (drums) intro video",
  "file": "lesson1d-intro.mp4",
  "lines": [
   "Welcome to your very first lesson. Grab some manuscript paper — you can download it free on this page — and let's start reading music.",
   "Drummers, in this course you'll see drum score side by side with the stave, so you learn the differences.",
   "This is the stave. It has five lines, and each line on its own is called a ledger line. We number the lines from the bottom to the top: one to five.",
   "Drum score uses the same five lines, but each line and space is a different drum. The bass drum is in the bottom space, the snare is in the third space, and cymbals like the hi-hat use an X above the stave.",
   "Notes can sit on the lines, or in the spaces in between. The higher a note sits on the stave, the higher it sounds — just like climbing a ladder.",
   "On drum score, a line or space doesn't give you a pitch. It tells you which drum or cymbal to hit, and the drums that sound lowest sit lowest on the stave.",
   "Need to go higher or lower? Draw a short ledger line through the note — keeping exactly the same spacing as the stave.",
   "Drum score uses ledger lines too. The crash cymbal is written with an X notehead on a ledger line above the stave.",
   "Then we give the notes letter names: A to G, and then they start again. On a keyboard, C is to the left of the two black keys, and F is to the left of the three.",
   "Drums don't use letter names, but the rest of the band does. Knowing them helps you follow the band's music and talk to the other musicians.",
   "Finally, a clef tells us where those letters sit. You'll meet the G clef, Middle C, and every note from Middle C up to A. Let's begin!",
   "Drum score starts with the percussion clef, two short thick lines, instead of a G or F clef, because its lines and spaces show drums, not pitches.",
   "Then play the drum games: name the drum on the score, which drum is it, write it on the drum score, and match the groove. See if you can beat your best score!"
  ]
 },
 {
  "id": "intro-2",
  "title": "Lesson 2 (piano) intro video",
  "file": "lesson2-intro.mp4",
  "lines": [
   "Welcome to lesson two. Have your manuscript paper and the lesson two worksheet ready — you'll find them both on this page.",
   "Lower notes are written in the bass clef. It's an F clef: its two dots sit either side of the fourth line, so the fourth line is the F below Middle C.",
   "The lines of the bass stave, from bottom to top, are G, B, D, F, A — Great Big Dogs From America. The spaces are A, C, E, G — All Cows Eat Grass.",
   "Put the notes on the lines and spaces together and climb from G on the bottom line, all the way up to Middle C, sitting on one ledger line just above the stave.",
   "Ledger lines in the Bass clef work exactly as with the Treble Clef: keep the same spacing, and keep alternating a line note and a space note, above and below the stave. Let's get reading!",
   "Pianists, you read both clefs at once on the grand staff. The right hand usually reads the treble clef, the left hand reads the bass clef, and Middle C sits between them. Let's get reading!"
  ]
 },
 {
  "id": "intro-2g",
  "title": "Lesson 2 (guitar) intro video",
  "file": "lesson2g-intro.mp4",
  "lines": [
   "Welcome to lesson two. Have your manuscript paper and the lesson two worksheet ready — you'll find them both on this page.",
   "Lower notes are written in the bass clef. It's an F clef: its two dots sit either side of the fourth line, so the fourth line is the F below Middle C.",
   "The lines of the bass stave, from bottom to top, are G, B, D, F, A — Great Big Dogs From America. The spaces are A, C, E, G — All Cows Eat Grass.",
   "Put the notes on the lines and spaces together and climb from G on the bottom line, all the way up to Middle C, sitting on one ledger line just above the stave.",
   "Ledger lines in the Bass clef work exactly as with the Treble Clef: keep the same spacing, and keep alternating a line note and a space note, above and below the stave. Let's get reading!",
   "Guitarists, guitar music is written in the treble clef, but reading the bass clef lets you read bass lines and piano parts too. Play the bass clef note game in this lesson: name each note and try to beat your best score."
  ]
 },
 {
  "id": "intro-2s",
  "title": "Lesson 2 (voice) intro video",
  "file": "lesson2s-intro.mp4",
  "lines": [
   "Welcome to lesson two. Have your manuscript paper and the lesson two worksheet ready — you'll find them both on this page.",
   "Lower notes are written in the bass clef. It's an F clef: its two dots sit either side of the fourth line, so the fourth line is the F below Middle C.",
   "The lines of the bass stave, from bottom to top, are G, B, D, F, A — Great Big Dogs From America. The spaces are A, C, E, G — All Cows Eat Grass.",
   "Put the notes on the lines and spaces together and climb from G on the bottom line, all the way up to Middle C, sitting on one ledger line just above the stave.",
   "Ledger lines in the Bass clef work exactly as with the Treble Clef: keep the same spacing, and keep alternating a line note and a space note, above and below the stave. Let's get reading!",
   "Singers, tenor and bass parts are usually written in the bass clef, so reading it helps you sing in a choir. Play the bass clef note game in this lesson: name each note and try to beat your best score."
  ]
 },
 {
  "id": "intro-2d",
  "title": "Lesson 2 (drums) intro video",
  "file": "lesson2d-intro.mp4",
  "lines": [
   "Welcome to lesson two: note values for drummers. Your lesson two worksheet is on this page.",
   "Duration works the same on drums. A crotchet, or quarter note, lasts one beat. Two quavers, or eighth notes, fit into one beat: count them one and, two and. Play the snare and say the count out loud — steady time is everything.",
   "In the band theory part of this lesson you'll meet the bass clef, which bass players and a pianist's left hand read. Its lines are G, B, D, F, A — Great Big Dogs From America — and the spaces are A, C, E, G — All Cows Eat Grass."
  ]
 },
 {
  "id": "intro-3",
  "title": "Lesson 3 (piano & voice) intro video",
  "file": "lesson3-intro.mp4",
  "lines": [
   "Welcome to lesson three: rhythm. Your lesson three worksheet is on this page, so print it out and keep it handy.",
   "A crotchet is a filled-in note with a stem, and it lasts for one beat. A minim is a hollow note with a stem, and it lasts for two beats.",
   "Stems follow a simple rule: below the middle line, the stem goes up on the right. Above the middle line, it goes down on the left. And on the middle line itself, the stem can go either way — up or down are both correct.",
   "Music is divided into bars by bar lines, and a double bar line shows the end of the piece.",
   "Time Signatures. The top number tells you how many beats are in every bar. The bottom number tells you the size or value of the beats you're counting. So if the bottom number is a 4, you are counting Crotchet beats. If the bottom number is a 2, you are counting Minim beats and if the bottom number is an 8, you are counting Quaver beats. So four four means four Crotchet beats in a bar. Three four means three crotchet beats in a bar. And two four means two crotchet beats in a bar. Let's count!"
  ]
 },
 {
  "id": "intro-3g",
  "title": "Lesson 3 (guitar) intro video",
  "file": "lesson3g-intro.mp4",
  "lines": [
   "Welcome to lesson three: rhythm. Your lesson three worksheet is on this page, so print it out and keep it handy.",
   "A crotchet is a filled-in note with a stem, and it lasts for one beat. A minim is a hollow note with a stem, and it lasts for two beats.",
   "Plain TAB shows you where to play, but not how long. That's why guitar music puts the stave above the TAB: read the rhythm from the notes on the stave, and the fret from the TAB.",
   "Stems follow a simple rule: below the middle line, the stem goes up on the right. Above the middle line, it goes down on the left. And on the middle line itself, the stem can go either way — up or down are both correct.",
   "Music is divided into bars by bar lines, and a double bar line shows the end of the piece.",
   "Time Signatures. The top number tells you how many beats are in every bar. The bottom number tells you the size or value of the beats you're counting. So if the bottom number is a 4, you are counting Crotchet beats. If the bottom number is a 2, you are counting Minim beats and if the bottom number is an 8, you are counting Quaver beats. So four four means four Crotchet beats in a bar. Three four means three crotchet beats in a bar. And two four means two crotchet beats in a bar. Let's count!",
   "Guitarists, strum along to feel it. In four four, play four down-strums in every bar, one on each crotchet beat, and count out loud."
  ]
 },
 {
  "id": "intro-3d",
  "title": "Lesson 3 (drums) intro video",
  "file": "lesson3d-intro.mp4",
  "lines": [
   "Welcome to lesson three: the basic rock beat. Your lesson three worksheet is on this page.",
   "The basic rock beat is the bread-and-butter groove: steady hi-hats on top, the snare on beats two and four, and the kick drum on one and three. Read it top to bottom at each beat.",
   "The snare on two and four is called the backbeat. It's what makes people nod their heads. Keep the hi-hat perfectly even: it's the glue.",
   "In band theory you'll meet the crotchet, which lasts one beat, and the minim, which lasts two. They work the same on drum score: a crotchet on the snare lasts one beat.",
   "The time signature tells you how many beats are in each bar. The rock beat is in four four: four crotchet beats, counted one, two, three, four."
  ]
 },
 {
  "id": "intro-4",
  "title": "Lesson 4 (piano & voice) intro video",
  "file": "lesson4-intro.mp4",
  "lines": [
   "Welcome to lesson four: longer and shorter notes, rests and ties. Your lesson four worksheet is on this page.",
   "A semibreve is a hollow note with no stem, lasting four beats. A dotted minim lasts three beats. A quaver lasts half a beat, and has a tail.",
   "Here's the rule for dots. A dot next to a note adds half the value of that note. A minim is two beats. Half of two is one. So a dotted minim is two plus one: three beats.",
   "Every note has a matching rest, a beat of silence. The semibreve rest hangs off the fourth line, the minim rest sits on the third line, and crotchet and quaver rests have their own shapes.",
   "A tie is a curved line joining two notes of the same pitch. Play the first note, and hold it for the value of both. Let's get counting!"
  ]
 },
 {
  "id": "intro-4g",
  "title": "Lesson 4 (guitar) intro video",
  "file": "lesson4g-intro.mp4",
  "lines": [
   "Welcome to lesson four: longer and shorter notes, rests and ties. Your lesson four worksheet is on this page.",
   "A semibreve is a hollow note with no stem, lasting four beats. A dotted minim lasts three beats. A quaver lasts half a beat, and has a tail.",
   "In guitar music, these note values are shown on the stave above the TAB. The TAB tells you the fret, and the stave tells you how long to let each note ring.",
   "Here's the rule for dots. A dot next to a note adds half the value of that note. A minim is two beats. Half of two is one. So a dotted minim is two plus one: three beats.",
   "Every note has a matching rest, a beat of silence. The semibreve rest hangs off the fourth line, the minim rest sits on the third line, and crotchet and quaver rests have their own shapes.",
   "A tie is a curved line joining two notes of the same pitch. Play the first note, and hold it for the value of both. Let's get counting!",
   "In TAB, a tied note is usually shown with its fret number in brackets. Don't pick it again: just let the first note ring on."
  ]
 },
 {
  "id": "intro-4d",
  "title": "Lesson 4 (drums) intro video",
  "file": "lesson4d-intro.mp4",
  "lines": [
   "Welcome to lesson four: rests and space in grooves. Your lesson four worksheet is on this page.",
   "Rests tell you when not to play. A rest is a measured silence, so keep counting and keep the pulse going. The space between hits shapes the groove as much as the notes.",
   "Try the snare on beats one and three, with a crotchet rest on two and four. Count the silent beats just as carefully as the played ones.",
   "In band theory you'll meet every rest. The semibreve rest hangs off the fourth line and the minim rest sits on the third line, on drum score too.",
   "You'll also meet ties, which join two notes of the same pitch into one longer note. On drums you can't hold a hit, so you'll mostly see ties on rolls and ringing cymbals."
  ]
 },
 {
  "id": "intro-4r",
  "title": "Lesson 4 notes into rests intro video",
  "file": "lesson4r-intro.mp4",
  "lines": [
   "For every note there's a rest that lasts for exactly the same length. A rest means silence, but you still count it. Let's turn each note into its rest.",
   "A semibreve lasts for four beats. Its rest, the semibreve rest, hangs off the fourth line. Four beats of silence: one, two, three, four. It's also called a whole bar's rest, because it fills an empty bar in any time signature.",
   "A dotted minim lasts for three beats. The dotted minim rest is a minim rest with a dot. Three beats of silence: one, two, three.",
   "A minim lasts for two beats. The minim rest sits on the third line. Two beats of silence: one, two.",
   "A crotchet lasts for one beat. The crotchet rest is a zig-zag shape. One beat of silence: one.",
   "A quaver lasts for half a beat. The quaver rest looks like a seven with a blob. Half a beat of silence: one and.",
   "Now try the rest spotting game and the Bar Builder. Remember, rests count too, so every bar must still add up to the time signature."
  ]
 },
 {
  "id": "intro-5",
  "title": "Lesson 5 (piano) intro video",
  "file": "lesson5-intro.mp4",
  "lines": [
   "Welcome to lesson five. Your lesson five worksheet is on this page — print it out before we start.",
   "An octave is the distance from one note to the next note with the same letter name, eight notes higher or lower. It sounds the same, just higher or lower.",
   "A semitone is the next immediate note, up or down, with no note in between. It can be two white notes, like B to C, or E to F. Or it can be a white note to a black note, like C to C sharp. Just no note in between.",
   "A tone misses out one note and goes to the next. It can have a black note in between, like C to D. Or it can have a white note in between, like E to F sharp.",
   "A sharp raises a note by a semitone. F sharp is the black note straight after F.",
   "A flat lowers a note by a semitone. B flat is the black note just before B.",
   "All accidentals are semitones: a sharp goes up one semitone, a flat goes down one semitone, and a natural cancels a sharp or flat.",
   "So every black note has two names. This black note is C sharp, or D flat."
  ]
 },
 {
  "id": "intro-5g",
  "title": "Lesson 5 (guitar) intro video",
  "file": "lesson5g-intro.mp4",
  "lines": [
   "Welcome to lesson five. Your lesson five worksheet is on this page — print it out before we start.",
   "An octave is the distance from one note to the next note with the same letter name, eight notes higher or lower. It sounds the same, just higher or lower.",
   "On the guitar, a semitone is one fret: the very next fret, up or down. A tone is two frets. B to C and E to F are semitones, just one fret apart.",
   "A sharp raises a note by one fret. F, on the first fret of the top E string, becomes F sharp on the second fret. A flat lowers a note by one fret, and a natural cancels a sharp or flat.",
   "So the fret between two natural notes has two names. The second fret of the top E string is F sharp, or G flat."
  ]
 },
 {
  "id": "intro-5s",
  "title": "Lesson 5 (voice) intro video",
  "file": "lesson5s-intro.mp4",
  "lines": [
   "Welcome to lesson five. Your lesson five worksheet is on this page — print it out before we start.",
   "An octave is the distance from one note to the next note with the same letter name, eight notes higher or lower. It sounds the same, just higher or lower.",
   "For singers, a semitone is the smallest step you'll sing: the very next note, up or down. A tone is two semitones. B to C and E to F are semitones.",
   "A sharp raises a note by a semitone, a flat lowers it by a semitone, and a natural cancels a sharp or flat. Use the Tone Tapper in this lesson to hear each step, then sing it back."
  ]
 },
 {
  "id": "intro-5d",
  "title": "Lesson 5 (drums) intro video",
  "file": "lesson5d-intro.mp4",
  "lines": [
   "Welcome to lesson five: eighth-note grooves. Your lesson five worksheet is on this page.",
   "Splitting each beat into two eighth notes, or quavers, gives grooves their drive. Play eighth notes on the hi-hat and count one and, two and, three and, four and.",
   "In band theory you'll learn the steps the rest of the band uses. A semitone is the very next note, a tone is two semitones, and sharps and flats raise or lower a note by a semitone. Knowing them helps you follow the band's charts."
  ]
 },
 {
  "id": "intro-6",
  "title": "Lesson 6 (piano) intro video",
  "file": "lesson6-intro.mp4",
  "lines": [
   "Welcome to lesson six: five-note practice. Your lesson six worksheet is on this page.",
   "We'll use just five notes: C, D, E, F and G. They sit next to each other, stepping from line to space on the stave.",
   "Give every finger a job. In the right hand, the thumb is one on C, up to the little finger, five, on G. In the left hand, the little finger, five, plays C, and the thumb plays G.",
   "Play up from C to G and back down, slowly and evenly. Say the note names out loud, keep every note the same length, and only speed up when it feels easy."
  ]
 },
 {
  "id": "intro-6g",
  "title": "Lesson 6 (guitar) intro video",
  "file": "lesson6g-intro.mp4",
  "lines": [
   "Welcome to lesson six: five-note practice. Your lesson six worksheet is on this page.",
   "We'll use just five notes: C, D, E, F and G. They sit next to each other, stepping from line to space on the stave.",
   "Guitarists, number your fretting fingers: index one, middle two, ring three, little four, and use one finger per fret. C is on the third fret of the A string. D is the open D string, E is on its second fret and F on its third fret. G is the open G string.",
   "Play up from C to G and back down, slowly and evenly. Say the note names out loud, keep every note the same length, and only speed up when it feels easy."
  ]
 },
 {
  "id": "intro-6s",
  "title": "Lesson 6 (voice) intro video",
  "file": "lesson6s-intro.mp4",
  "lines": [
   "Welcome to lesson six: five-note practice. Your lesson six worksheet is on this page.",
   "We'll use just five notes: C, D, E, F and G. They sit next to each other, stepping from line to space on the stave.",
   "Singers, sing C, D, E, F and G on letter names first, then on sol-fa: do, re, mi, fa, sol.",
   "Sing up from C to G and back down, slowly and evenly. Keep every note the same length and in tune, and only speed up when it feels easy."
  ]
 },
 {
  "id": "intro-6d",
  "title": "Lesson 6 (drums) intro video",
  "file": "lesson6d-intro.mp4",
  "lines": [
   "Welcome to lesson six: sixteenth notes and subdivision. Your lesson six worksheet is on this page.",
   "Four sixteenth notes, or semiquavers, fit into one beat. Count them one e and a, two e and a. Play them evenly on the snare: they add detail and funk to grooves.",
   "In band theory, see how the rest of the band practises five notes, C, D, E, F and G — the building blocks of the tunes you'll play along with."
  ]
 },
 {
  "id": "intro-7",
  "title": "Lesson 7 (piano) intro video",
  "file": "lesson7-intro.mp4",
  "lines": [
   "Welcome to lesson seven: the major scale formula. Your lesson seven worksheet is on this page.",
   "Every major scale is built from the same pattern of steps: tone, tone, semitone, tone, tone, tone, semitone.",
   "In C major, the two semitones fall between E and F, and between B and C — exactly where there's no black key in between. That's why C major uses only white keys.",
   "Pianists, play C major with the right hand: one, two, three, thumb under, one, two, three, four, five. And the left hand: five, four, three, two, one, third finger over, three, two, one."
  ]
 },
 {
  "id": "intro-7g",
  "title": "Lesson 7 (guitar) intro video",
  "file": "lesson7g-intro.mp4",
  "lines": [
   "Welcome to lesson seven: the major scale formula. Your lesson seven worksheet is on this page.",
   "Every major scale is built from the same pattern of steps: tone, tone, semitone, tone, tone, tone, semitone.",
   "On guitar, a tone is two frets and a semitone is one fret. So along a single string, C major moves two frets, two frets, one fret, then two, two, two and one.",
   "Then play C major in first position across the strings, saying each note name as you go."
  ]
 },
 {
  "id": "intro-7s",
  "title": "Lesson 7 (voice) intro video",
  "file": "lesson7s-intro.mp4",
  "lines": [
   "Welcome to lesson seven: the major scale formula. Your lesson seven worksheet is on this page.",
   "Every major scale is built from the same pattern of steps: tone, tone, semitone, tone, tone, tone, semitone.",
   "Singers, the semitones are the small steps: from mi to fa, and from ti to do. Sing C major on do, re, mi, fa, sol, la, ti, do, up and down, slowly and in tune."
  ]
 },
 {
  "id": "intro-7d",
  "title": "Lesson 7 (drums) intro video",
  "file": "lesson7d-intro.mp4",
  "lines": [
   "Welcome to lesson seven: reading drum fills. Your lesson seven worksheet is on this page.",
   "A fill is a short break from the groove, usually running down the toms to signal a new section. It often lands on a crash on beat one.",
   "In band theory: every major scale follows the same pattern, tone, tone, semitone, tone, tone, tone, semitone — the pattern behind the songs you'll play."
  ]
 },
 {
  "id": "intro-8",
  "title": "Lesson 8 (piano & voice) intro video",
  "file": "lesson8-intro.mp4",
  "lines": [
   "Welcome to lesson eight: major scales in different keys. Your lesson eight worksheet is on this page.",
   "Start the formula, tone, tone, semitone, tone, tone, tone, semitone, on G. To keep the pattern, F has to become F sharp. So G major has one sharp.",
   "Instead of writing the sharp every time, we put it at the start of the stave. This is the key signature. One sharp is G major. One flat, B flat, is F major. Two sharps, F sharp and C sharp, is D major.",
   "Sharps always appear in the same order: Father Charles Goes Down And Ends Battle. And the flats are the same, backwards: Battle Ends And Down Goes Charles' Father."
  ]
 },
 {
  "id": "intro-8g",
  "title": "Lesson 8 (guitar) intro video",
  "file": "lesson8g-intro.mp4",
  "lines": [
   "Welcome to lesson eight: major scales in different keys. Your lesson eight worksheet is on this page.",
   "Start the formula, tone, tone, semitone, tone, tone, tone, semitone, on G. To keep the pattern, F has to become F sharp. So G major has one sharp.",
   "On the guitar, F sharp is one fret above F. On the top E string, F is the first fret and F sharp is the second fret.",
   "Instead of writing the sharp every time, we put it at the start of the stave. This is the key signature. One sharp is G major. One flat, B flat, is F major. Two sharps, F sharp and C sharp, is D major.",
   "When the key signature has one sharp, every F you play becomes F sharp, on every string and in every octave, unless a natural cancels it.",
   "Sharps always appear in the same order: Father Charles Goes Down And Ends Battle. And the flats are the same, backwards: Battle Ends And Down Goes Charles' Father."
  ]
 },
 {
  "id": "intro-8d",
  "title": "Lesson 8 (drums) intro video",
  "file": "lesson8d-intro.mp4",
  "lines": [
   "Welcome to lesson eight: time signatures for drummers. Your lesson eight worksheet is on this page.",
   "The time signature tells you how many beats fill a bar. Four four is the standard, three four is a waltz, and six eight has a rolling feel, felt in two big pulses of three.",
   "Here's one bar of three four: kick, snare, snare. Feel the ONE, two, three waltz pulse.",
   "In band theory you'll learn key signatures: G major has one sharp and F major has one flat. Drums don't change with the key, but the band's charts do, so knowing the key signature helps you follow them."
  ]
 },
 {
  "id": "intro-9",
  "title": "Lesson 9 (piano) intro video",
  "file": "lesson9-intro.mp4",
  "lines": [
   "Welcome to lesson nine: naming scales. Your lesson nine worksheet is on this page.",
   "You can name every note of a scale three ways. With numbers, one to eight. With letter names, C D E F G A B C. And with sol-fa: do, re, mi, fa, sol, la, ti, do.",
   "Do is always the key note, so it moves with the key. In G major, do is G — and the pattern of sol-fa stays exactly the same.",
   "Now build new scales. A natural minor uses the same notes as C major, but starts on A, so it sounds darker. And the major pentatonic uses just five notes: one, two, three, five and six.",
   "Pianists, play each scale slowly and say the numbers, letter names or sol-fa as you go."
  ]
 },
 {
  "id": "intro-9g",
  "title": "Lesson 9 (guitar) intro video",
  "file": "lesson9g-intro.mp4",
  "lines": [
   "Welcome to lesson nine: naming scales. Your lesson nine worksheet is on this page.",
   "You can name every note of a scale three ways. With numbers, one to eight. With letter names, C D E F G A B C. And with sol-fa: do, re, mi, fa, sol, la, ti, do.",
   "Do is always the key note, so it moves with the key. In G major, do is G — and the pattern of sol-fa stays exactly the same.",
   "Now build new scales. A natural minor uses the same notes as C major, but starts on A, so it sounds darker. And the major pentatonic uses just five notes: one, two, three, five and six.",
   "Guitarists, play each scale on the neck and say the numbers, letter names or sol-fa as you go."
  ]
 },
 {
  "id": "intro-9s",
  "title": "Lesson 9 (voice) intro video",
  "file": "lesson9s-intro.mp4",
  "lines": [
   "Welcome to lesson nine: naming scales. Your lesson nine worksheet is on this page.",
   "You can name every note of a scale three ways. With numbers, one to eight. With letter names, C D E F G A B C. And with sol-fa: do, re, mi, fa, sol, la, ti, do.",
   "Do is always the key note, so it moves with the key. In G major, do is G — and the pattern of sol-fa stays exactly the same.",
   "Now build new scales. A natural minor uses the same notes as C major, but starts on A, so it sounds darker. And the major pentatonic uses just five notes: one, two, three, five and six.",
   "Singers, sing every scale on sol-fa. Remember, do moves with the key, so the same sol-fa fits every major scale."
  ]
 },
 {
  "id": "intro-9d",
  "title": "Lesson 9 (drums) intro video",
  "file": "lesson9d-intro.mp4",
  "lines": [
   "Welcome to lesson nine: dynamics, accents and ghost notes. Your lesson nine worksheet is on this page.",
   "An accent, marked with a sideways V above the note, is a louder hit. Ghost notes are whisper-quiet snare notes that add groove and feel.",
   "In band theory, the band names scale notes three ways: numbers, one to eight, letter names, and sol-fa: do, re, mi, fa, sol, la, ti, do."
  ]
 },
 {
  "id": "intro-10",
  "title": "Lesson 10 (piano) intro video",
  "file": "lesson10-intro.mp4",
  "lines": [
   "Welcome to lesson ten: triads, chords and arpeggios. Your lesson ten worksheet is on this page.",
   "A triad is three notes: a root, a third and a fifth, stacked like a snowman on lines or in spaces. Build one on every note of C major and you get seven chords.",
   "Chords one, four and five are major. Two, three and six are minor. And seven is diminished.",
   "Play the notes together and it's a block chord. One at a time, it's a broken chord. Keep climbing and it becomes an arpeggio. To harmonise a tune, play a chord that contains the melody note — like a C chord under an E or a G."
  ]
 },
 {
  "id": "intro-10g",
  "title": "Lesson 10 (guitar) intro video",
  "file": "lesson10g-intro.mp4",
  "lines": [
   "Welcome to lesson ten: triads, chords and arpeggios. Your lesson ten worksheet is on this page.",
   "A triad is three notes: a root, a third and a fifth, stacked like a snowman on lines or in spaces. Build one on every note of C major and you get seven chords.",
   "Chords one, four and five are major. Two, three and six are minor. And seven is diminished.",
   "Strum the notes together and it's a block chord. Pick them one at a time and it's a broken chord. Keep climbing and it becomes an arpeggio.",
   "Guitarists, chord symbols tell you which chord to play. A letter on its own is major. A small m means minor. Dim is diminished, aug is augmented, and a slash shows the bass note, so C slash E is a C chord with E in the bass.",
   "You can play the same chord in different positions on the neck. C can be the open shape, a barre at the third fret, a barre at the eighth fret, or a small triad on the top strings. Choose the one closest to the next chord, so your hand moves as little as possible."
  ]
 },
 {
  "id": "intro-10s",
  "title": "Lesson 10 (voice) intro video",
  "file": "lesson10s-intro.mp4",
  "lines": [
   "Welcome to lesson ten: triads, chords and arpeggios. Your lesson ten worksheet is on this page.",
   "A triad is three notes: a root, a third and a fifth, stacked like a snowman on lines or in spaces. Build one on every note of C major and you get seven chords.",
   "Chords one, four and five are major. Two, three and six are minor. And seven is diminished.",
   "Sing the notes of a chord one at a time and it's a broken chord. Keep climbing and it becomes an arpeggio. To harmonise, sing a note from the chord — like E or G over a C chord — while someone else sings the tune."
  ]
 },
 {
  "id": "intro-10d",
  "title": "Lesson 10 (drums) intro video",
  "file": "lesson10d-intro.mp4",
  "lines": [
   "Welcome to lesson ten: reading a full groove chart. Your lesson ten worksheet is on this page.",
   "Combine hi-hat, snare and kick, and read a full bar of groove fluently: top to bottom, left to right.",
   "In band theory, a triad is three notes: a root, a third and a fifth. Chords one, four and five are major, two, three and six are minor, and seven is diminished."
  ]
 },
 {
  "id": "welcome-pianists",
  "title": "Welcome video (piano course page)",
  "file": "welcome-pianists.mp4",
  "lines": [
   "Welcome, and thank you for purchasing this course. You won't regret it!",
   "Whether you're on the Beginner to Intermediate course, the Intermediate to Advanced course, or the Gospel course, there's something here for you.",
   "As a pianist, you'll read the grand staff with both hands: the treble clef for your right hand and the bass clef for your left. You'll learn fingering, five-finger practice, major scales, chords and arpeggios, and play along with real backing tracks.",
   "Remember, the Ask the Music Helper button is at the bottom right of every page. And if you're still stuck, you can reach out to me directly with the Ask Jason box on your course page. I'll reply within 24 hours. Let's get started!"
  ]
 },
 {
  "id": "welcome-guitarists",
  "title": "Welcome video (guitar course page)",
  "file": "welcome-guitarists.mp4",
  "lines": [
   "Welcome, and thank you for purchasing this course. You won't regret it!",
   "Whether you're on the Beginner to Intermediate course, the Intermediate to Advanced course, or the Gospel course, there's something here for you.",
   "As a guitarist, every lesson shows the stave and TAB side by side, so you can read the notes and know exactly where to play them on the fretboard. You'll learn chord symbols, scales in different positions, and how to play the same chord in different places on the neck.",
   "Remember, the Ask the Music Helper button is at the bottom right of every page. And if you're still stuck, you can reach out to me directly with the Ask Jason box on your course page. I'll reply within 24 hours. Let's get started!"
  ]
 },
 {
  "id": "welcome-drummers",
  "title": "Welcome video (drums course page)",
  "file": "welcome-drummers.mp4",
  "lines": [
   "Welcome, and thank you for purchasing this course. You won't regret it!",
   "Whether you're on the Beginner to Intermediate course, or the Intermediate to Advanced course, there's something here for you.",
   "As a drummer, you'll read drum score side by side with the stave, starting with your first rock beat and building up to full groove charts. You'll create your own beats in the Groove Builder, and learn the band theory that helps you follow the rest of the band.",
   "Remember, the Ask the Music Helper button is at the bottom right of every page. And if you're still stuck, you can reach out to me directly with the Ask Jason box on your course page. I'll reply within 24 hours. Let's get started!"
  ]
 },
 {
  "id": "welcome-singers",
  "title": "Welcome video (voice course page)",
  "file": "welcome-singers.mp4",
  "lines": [
   "Welcome, and thank you for purchasing this course. You won't regret it!",
   "Whether you're on the Beginner to Intermediate course, or the Intermediate to Advanced course, there's something here for you.",
   "As a singer, you'll see the stave next to the keyboard and the words you sing. You'll find your range and your voice part, sing scales on sol-fa, and check your notes with the microphone singing games.",
   "Remember, the Ask the Music Helper button is at the bottom right of every page. And if you're still stuck, you can reach out to me directly with the Ask Jason box on your course page. I'll reply within 24 hours. Let's get started!"
  ]
 },
 {
  "id": "countalong-3",
  "title": "Lesson 3 count-along video",
  "file": "lesson3-countalong.mp4",
  "lines": [
   "Let's count along! Don't just clap all the way through. Clap once on each crotchet. On a minim, clap once, then hold your hands together for two beats while you keep counting. Listen for the clicks first.",
   "Four four: four crotchet beats in a bar. A crotchet is one clap. A minim is one clap, then hold it for two beats. Clap and count with me.",
   "Three four: three crotchet beats in a bar. Remember, clap once on a minim and hold it for two.",
   "Two four: two crotchet beats in a bar. A minim fills the whole bar: clap once and hold."
  ]
 },
 {
  "id": "countalong-4",
  "title": "Lesson 4 count-along video",
  "file": "lesson4-countalong.mp4",
  "lines": [
   "Let's count along with longer and shorter notes. Clap on every note and keep counting through the long ones.",
   "Semibreves: clap once and hold for four counts.",
   "Dotted minims in three four: clap once and hold for three.",
   "Quavers are half a beat. Count one and two and.",
   "Now mix them all together in four four."
  ]
 },
 {
  "id": "countalong-5",
  "title": "Lesson 5 count-along video",
  "file": "lesson5-countalong.mp4",
  "lines": [
   "Let's count along in the bass clef. Listen to each note, and count out loud with me.",
   "The bass clef. Walk up from G on the bottom line, counting four crotchet beats in every bar.",
   "Octave jumps: the same letter name, eight notes apart. Low C, then high C."
  ]
 },
 {
  "id": "countalong-6",
  "title": "Lesson 6 count-along video",
  "file": "lesson6-countalong.mp4",
  "lines": [
   "Let's count along with our first tune. Play or sing along, and count out loud.",
   "Ode to Joy, using just five notes from C to G. Count four beats in every bar.",
   "Now the second line. It ends on C."
  ]
 },
 {
  "id": "countalong-7",
  "title": "Lesson 7 count-along video",
  "file": "lesson7-countalong.mp4",
  "lines": [
   "Let's count along with the C major scale. Play or sing each note, and keep a steady count.",
   "The C major scale going up, in crotchets. Tone, tone, semitone, tone, tone, tone, semitone.",
   "And coming back down.",
   "Now go up again in minims: two beats on every note."
  ]
 },
 {
  "id": "countalong-8",
  "title": "Lesson 8 count-along video",
  "file": "lesson8-countalong.mp4",
  "lines": [
   "Let's count along with scales in new keys. Listen out for the sharps and flats.",
   "G major in quavers. Remember F sharp! Count one and two and three and four and.",
   "And back down.",
   "F major in crotchets. Remember B flat!"
  ]
 },
 {
  "id": "countalong-9",
  "title": "Lesson 9 count-along video",
  "file": "lesson9-countalong.mp4",
  "lines": [
   "Let's sing along with sol-fa. Do is C, the key note of C major.",
   "Sing the sol-fa names in time with me, going up the C major scale.",
   "And coming down.",
   "Now jump: Do, Mi, Sol, Do. That's the C major chord."
  ]
 },
 {
  "id": "countalong-10",
  "title": "Lesson 10 count-along video",
  "file": "lesson10-countalong.mp4",
  "lines": [
   "Let's count along with chords. Listen to the three notes of each triad.",
   "Block chords: all three notes together. One chord for each bar, held for four beats.",
   "Broken chords: the same notes, one at a time."
  ]
 }
];
